function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#3D99DD"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.9055 13.0663C31.0916 10.5836 26.949 10.1841 26.6512 12.7146C24.0615 13.0556 19.6849 14.1371 17.3132 17.5413C15.0904 20.7378 14.5054 25.0371 14.3884 26.108C11.7242 28.0365 9.37377 29.4856 8.31021 30.5031C7.95647 30.8438 7.89816 31.3898 8.17195 31.7977C8.31559 32.0198 8.54154 32.1755 8.79993 32.2305C9.05832 32.2854 9.32792 32.2352 9.54926 32.0907C9.67688 32.0055 10.8947 31.2916 14.0428 31.7391C19.7062 32.5436 18.4725 35.4684 24.5348 34.9356C29.7994 34.4561 32.9741 30.6736 33.7824 29.6081C34.7874 29.6561 35.7712 29.72 36.7603 29.8479C37.4321 30.0029 38.1368 29.9201 38.7545 29.6134C39.2912 29.2636 39.6545 28.7021 39.7543 28.0685C39.9442 27.0357 40.0244 25.9856 39.9936 24.9359C39.9829 18.8626 36.5636 14.8776 30.9055 13.0663ZM20.3178 26.0707C20.6368 23.3696 22.163 14.9575 28.6507 13.6523C33.5856 16.4386 31.1873 25.9055 30.496 28.2869C26.4651 27.7009 22.4396 26.4702 20.3178 26.0707ZM29.8366 12.7519C29.1713 12.5423 28.4653 12.4966 27.7786 12.6187C28.0711 11.8143 29.6877 11.9368 29.8366 12.7679V12.7519ZM18.2119 18.154C19.8445 15.7993 22.6523 14.6698 24.9602 14.1264C20.706 17.2004 19.552 23.5454 19.2648 25.9375C18.0318 25.7649 16.784 25.7239 15.5424 25.8149C15.7232 24.3392 16.3773 20.7858 18.2119 18.154ZM24.439 33.8648C18.8235 34.3975 20.1848 31.526 14.1917 30.6683C11.5647 30.2954 10.0864 30.6683 9.40568 30.9613C10.5543 29.997 12.7878 28.6012 15.1223 26.9124C20.0838 26.1666 25.8483 29.1606 32.4636 29.5762C30.4343 31.9807 27.5627 33.5154 24.439 33.8648ZM38.712 27.8394C38.4939 28.8729 37.9515 28.9528 36.8986 28.8143C34.5747 28.5107 33.3038 28.6066 31.5808 28.4201C32.8039 24.1581 33.7079 17.6532 30.948 14.2063C34.7662 15.5222 37.6484 17.9356 38.6003 21.9419C39.0103 23.8828 39.0482 25.8842 38.712 27.8394Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.5
});

var SvgFitnessSports = function SvgFitnessSports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFitnessSports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fitness_sports.8e04f4cb.svg";
export { ForwardRef as ReactComponent };